import * as AnnouncementActions from '../actions/update.actions';
import { defaultAnnouncementForm } from '../../constants';

const initialState = {
  loading: false,
  submitting: false,
  submitSuccess: false,
  announcementForm: defaultAnnouncementForm,
  error: null,
  message: '',
};

const mapDetailToForm = (data) => ({
  title: data.title || '',
  content: data.content || '',
  startDate: data.startDate || null,
  endDate: data.endDate || null,
  status: data.status ?? 0,
});

const update = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case AnnouncementActions.GET_ANNOUNCEMENT_DETAIL:
      return { ...state, loading: true, error: null };
    case AnnouncementActions.GET_ANNOUNCEMENT_DETAIL_SUCCESS:
      return { ...state, loading: false, announcementForm: mapDetailToForm(payload.data) };
    case AnnouncementActions.GET_ANNOUNCEMENT_DETAIL_FAIL:
      return { ...state, loading: false, message: payload.message, error: payload.error };
    case AnnouncementActions.UPDATE_ANNOUNCEMENT:
      return { ...state, submitting: true, submitSuccess: false, error: null };
    case AnnouncementActions.UPDATE_ANNOUNCEMENT_SUCCESS:
      return { ...state, submitting: false, submitSuccess: true };
    case AnnouncementActions.UPDATE_ANNOUNCEMENT_FAIL:
      return { ...state, submitting: false, submitSuccess: false, message: payload.message, error: payload.error };
    case AnnouncementActions.CLEAR_ANNOUNCEMENT_UPDATE_FORM:
      return initialState;
    case AnnouncementActions.CHANGE_ANNOUNCEMENT_UPDATE_FORM:
      return { ...state, announcementForm: { ...state.announcementForm, ...payload.data } };
    default:
      return state;
  }
};

export default update;
